import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Dropdown, type MenuProps, Modal } from 'antd';
import {
  ExclamationCircleOutlined,
  IdcardOutlined,
  LogoutOutlined,
  MailOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { cleanTokens } from 'services/auth';
import { useGetMyClientUser } from 'client-app/api/client-user/use-get-my-client-user.ts';
import { clientRouterPaths } from 'client-app/router/client-router-paths.ts';
import { useClientAuthStore } from 'client-app/stores/use-client-auth-store.ts';
import styles from './client-user-menu.module.scss';

export const ClientUserMenu = () => {
  const { clearAuth } = useClientAuthStore();
  const navigate = useNavigate();
  const { data: clientInfo } = useGetMyClientUser();
  const { t } = useTranslation();

  const confirm = () => {
    Modal.confirm({
      title: t('common:logout'),
      icon: <ExclamationCircleOutlined />,
      content: t('common:logout_confirm_text'),
      okText: t('common:logout'),
      cancelText: t('common:cancel'),
      onOk() {
        cleanTokens();
        clearAuth();
        navigate(clientRouterPaths.auth);
      },
    });
  };

  const handleDropdownClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'logout') {
      confirm();
    }
  };

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          {
            className: styles.menuItem,
            key: 'name',
            label: clientInfo?.name,
            icon: <IdcardOutlined />,
            disabled: true,
          },
          {
            className: styles.menuItem,
            key: 'email',
            label: clientInfo?.email,
            icon: <MailOutlined />,
            disabled: true,
          },
          {
            type: 'divider',
          },
          {
            key: 'logout',
            label: t('common:logout'),
            icon: <LogoutOutlined />,
          },
        ],
        onClick: handleDropdownClick,
      }}
      placement='bottomLeft'>
      <Button icon={<UserOutlined />} type='text' />
    </Dropdown>
  );
};
